import { Pipe, PipeTransform, inject } from '@angular/core';
import { Product } from '@pedix-workspace/utils';
import { StockService } from './stock.service';
import { map, Observable } from 'rxjs';
import { StockMap } from '@pedix-workspace/shared-stock';
import { toObservable } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Pipe({
  name: 'pxwStockIsOutOfStock',
  standalone: true,
})
export class StockIsOutOfStockPipe implements PipeTransform {
  private stockService = inject(StockService);

  stock$: Observable<StockMap>;

  constructor() {
    this.stock$ = toObservable(this.stockService.stock);
  }

  transform(product: Pick<Product, 'id' | 'presentations'>): Observable<boolean> {
    return this.stock$.pipe(
      untilDestroyed(this),
      map(stock => {
        if (product.presentations) {
          return (
            product.presentations?.items?.every(
              item => stock.getStockInfoByItem(item.id).isOutOfStock,
            ) || false
          );
        } else {
          return stock.getStockInfoByItem(product.id).isOutOfStock;
        }
      }),
    );
  }
}
